import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _countWalletsRequest = {};
var _countWalletsResponse = {};
var _createCustomerReferenceRequest = {};
var _createCustomerReferenceResponse = {};
var _createWalletRequest = {};
var _createWalletResponse = { wallet: '_wallet' };
var _deleteCustomerReferenceRequest = {};
var _deleteCustomerReferenceResponse = {};
var _getCustomerReferenceRequest = {};
var _getCustomerReferenceResponse = {};
var _getOrCreateWalletRequest = {};
var _getOrCreateWalletResponse = { wallet: '_wallet' };
var _getWalletGiftCardRequest = {};
var _getWalletGiftCardResponse = { giftCard: '_giftCard' };
var _getWalletRequest = {};
var _getWalletResponse = { wallet: '_wallet' };
var _giftCard = {
    expirationDate: 'google.protobuf.Timestamp',
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    disableDate: 'google.protobuf.Timestamp',
};
var _queryWalletsByContactRequest = {};
var _queryWalletsByContactResponse = { wallets: '_wallet' };
var _queryWalletsRequest = {};
var _queryWalletsResponse = { wallets: '_wallet' };
var _updateCustomerReferenceRequest = {};
var _updateCustomerReferenceResponse = {};
var _wallet = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
function resolveWixRiseV1WalletServiceUrl(opts) {
    var domainToMappings = {
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/wallet-service',
                destPath: '/v1/rise',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/wallet-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/wallet-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/wallet-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wallet-service',
                destPath: '/v1/rise',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/rise/v1/wallet-service',
                destPath: '/v1/rise',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/wallet-service',
                destPath: '/v1/rise',
            },
        ],
        'platform.rise.ai': [
            {
                srcPath: '/v1/rise/wallets',
                destPath: '/v1/rise/wallets',
            },
            {
                srcPath: '/v1/rise/customers',
                destPath: '/v1/rise/customers',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new Wallet */
export function createWallet(payload) {
    var _a = serializer(_createWalletRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createWalletResponse, { _wallet: _wallet }).fromJSON;
    function __createWallet(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet',
            method: 'POST',
            methodFqn: 'wix.rise.v1.WalletService.CreateWallet',
            url: resolveWixRiseV1WalletServiceUrl({
                protoPath: '/v1/rise/wallets',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createWallet.fromReq = fromReq;
    __createWallet.__isAmbassador = true;
    return __createWallet;
}
/**
 * Creates a new Wallet.
 * In case no Wallet exists - Creates a new wallet as well
 * if both Wallet and Customer Reference exist - doesn't update anything
 */
export function getOrCreateWallet(payload) {
    var _a = serializer(_getOrCreateWalletRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOrCreateWalletResponse, {
        _wallet: _wallet,
    }).fromJSON;
    function __getOrCreateWallet(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet',
            method: 'POST',
            methodFqn: 'wix.rise.v1.WalletService.GetOrCreateWallet',
            url: resolveWixRiseV1WalletServiceUrl({
                protoPath: '/v1/rise/wallets/issue',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOrCreateWallet.fromReq = fromReq;
    __getOrCreateWallet.__isAmbassador = true;
    return __getOrCreateWallet;
}
export function createCustomerReference(payload) {
    var _a = serializer(_createCustomerReferenceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCustomerReferenceResponse, {}).fromJSON;
    function __createCustomerReference(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet',
            method: 'POST',
            methodFqn: 'wix.rise.v1.WalletService.CreateCustomerReference',
            url: resolveWixRiseV1WalletServiceUrl({
                protoPath: '/v1/rise/customers',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCustomerReference.fromReq = fromReq;
    __createCustomerReference.__isAmbassador = true;
    return __createCustomerReference;
}
/** Get a CustomerReference */
export function getCustomerReference(payload) {
    var _a = serializer(_getCustomerReferenceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCustomerReferenceResponse, {}).fromJSON;
    function __getCustomerReference(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet',
            method: 'GET',
            methodFqn: 'wix.rise.v1.WalletService.GetCustomerReference',
            url: resolveWixRiseV1WalletServiceUrl({
                protoPath: '/v1/rise/customers',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCustomerReference.fromReq = fromReq;
    __getCustomerReference.__isAmbassador = true;
    return __getCustomerReference;
}
/** Update CustomerReference */
export function updateCustomerReference(payload) {
    var _a = serializer(_updateCustomerReferenceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCustomerReferenceResponse, {}).fromJSON;
    function __updateCustomerReference(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet',
            method: 'PATCH',
            methodFqn: 'wix.rise.v1.WalletService.UpdateCustomerReference',
            url: resolveWixRiseV1WalletServiceUrl({
                protoPath: '/v1/rise/customers',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCustomerReference.fromReq = fromReq;
    __updateCustomerReference.__isAmbassador = true;
    return __updateCustomerReference;
}
/** Delete a CustomerReference */
export function deleteCustomerReference(payload) {
    var _a = serializer(_deleteCustomerReferenceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCustomerReferenceResponse, {}).fromJSON;
    function __deleteCustomerReference(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet',
            method: 'DELETE',
            methodFqn: 'wix.rise.v1.WalletService.DeleteCustomerReference',
            url: resolveWixRiseV1WalletServiceUrl({
                protoPath: '/v1/rise/customers',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCustomerReference.fromReq = fromReq;
    __deleteCustomerReference.__isAmbassador = true;
    return __deleteCustomerReference;
}
/** Get a Wallet by ID */
export function getWallet(payload) {
    var _a = serializer(_getWalletRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getWalletResponse, { _wallet: _wallet }).fromJSON;
    function __getWallet(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet',
            method: 'GET',
            methodFqn: 'wix.rise.v1.WalletService.GetWallet',
            url: resolveWixRiseV1WalletServiceUrl({
                protoPath: '/v1/rise/wallets',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getWallet.fromReq = fromReq;
    __getWallet.__isAmbassador = true;
    return __getWallet;
}
/** Get a Wallet's Gift Card */
export function getWalletGiftCard(payload) {
    var _a = serializer(_getWalletGiftCardRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getWalletGiftCardResponse, {
        _giftCard: _giftCard,
    }).fromJSON;
    function __getWalletGiftCard(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet',
            method: 'GET',
            methodFqn: 'wix.rise.v1.WalletService.GetWalletGiftCard',
            url: resolveWixRiseV1WalletServiceUrl({
                protoPath: '/v1/rise/wallets/gift-card',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getWalletGiftCard.fromReq = fromReq;
    __getWalletGiftCard.__isAmbassador = true;
    return __getWalletGiftCard;
}
/** Query wallets enriched with gift card and contact information */
export function queryWallets(payload) {
    var _a = serializer(_queryWalletsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryWalletsResponse, { _wallet: _wallet }).fromJSON;
    function __queryWallets(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet',
            method: 'POST',
            methodFqn: 'wix.rise.v1.WalletService.QueryWallets',
            url: resolveWixRiseV1WalletServiceUrl({
                protoPath: '/v1/rise/wallets/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryWallets.fromReq = fromReq;
    __queryWallets.__isAmbassador = true;
    return __queryWallets;
}
export function countWallets(payload) {
    var _a = serializer(_countWalletsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countWalletsResponse, {}).fromJSON;
    function __countWallets(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet',
            method: 'POST',
            methodFqn: 'wix.rise.v1.WalletService.CountWallets',
            url: resolveWixRiseV1WalletServiceUrl({
                protoPath: '/v1/rise/wallets/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countWallets.fromReq = fromReq;
    __countWallets.__isAmbassador = true;
    return __countWallets;
}
export function queryWalletsByContact(payload) {
    var _a = serializer(_queryWalletsByContactRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryWalletsByContactResponse, {
        _wallet: _wallet,
    }).fromJSON;
    function __queryWalletsByContact(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet',
            method: 'POST',
            methodFqn: 'wix.rise.v1.WalletService.QueryWalletsByContact',
            url: resolveWixRiseV1WalletServiceUrl({
                protoPath: '/v1/rise/wallets/query_by_contact',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryWalletsByContact.fromReq = fromReq;
    __queryWalletsByContact.__isAmbassador = true;
    return __queryWalletsByContact;
}
//# sourceMappingURL=http.impl.js.map